var _style, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNaranja(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 80",
    style: {
      enableBackground: "new 0 0 100 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FF9E16;}\r\n\t.st1{fill:url(#SVGID_1_);}\r\n\t.st2{fill:#FF5000;}\r\n\t.st3{fill:#98252B;}\r\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26,55.3v-8.9c7.5,0,13.6-6,13.6-13.4V20.7h9.1V33C48.7,45.3,38.5,55.3,26,55.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -867.6225,
    y1: 565.708,
    x2: -866.8066,
    y2: 565.5675,
    gradientTransform: "matrix(22.667 0 0 -34.666 19695.3027 19646.6133)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9E16",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#FD9516",
      stopOpacity: 0.07
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "#F67717",
      stopOpacity: 0.31
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#F05E18",
      stopOpacity: 0.52
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#EB4819",
      stopOpacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    style: {
      stopColor: "#E73819",
      stopOpacity: 0.83
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    style: {
      stopColor: "#E42C1A",
      stopOpacity: 0.92
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#E3251A",
      stopOpacity: 0.98
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    style: {
      stopColor: "#E2231A"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26,55.3v-8.9c7.5,0,13.6-6,13.6-13.4V20.7h9.1V33C48.7,45.3,38.5,55.3,26,55.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M73.7,17.8c0.2,0.2,0.3,0.6,0.3,0.9c0,0.7-0.6,1.3-1.3,1.3c0,0,0,0,0,0c-0.4,0-0.7-0.1-0.9-0.4 c-0.3-0.3-0.4-0.6-0.4-1c0-0.4,0.2-0.7,0.4-1c0.2-0.2,0.6-0.3,0.9-0.3C73,17.3,73.4,17.5,73.7,17.8L73.7,17.8z M71.9,18 c-0.2,0.2-0.3,0.4-0.3,0.7c0,0.3,0.1,0.6,0.3,0.8c0.4,0.4,1.1,0.3,1.5-0.1c0.2-0.2,0.3-0.4,0.3-0.7c0-0.3-0.1-0.6-0.4-0.8 c-0.2-0.2-0.4-0.3-0.7-0.3C72.4,17.6,72.1,17.8,71.9,18C71.9,18,71.9,18,71.9,18z M73.1,18.4c-0.2-0.2-0.2-0.2-0.4-0.2 c-0.1,0-0.2,0-0.3,0.1c-0.1,0.1-0.1,0.2-0.1,0.3c0,0.1,0,0.3,0.1,0.3c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,0.1,0,0.2,0 c0.1,0,0.1-0.1,0.2-0.2l0.2,0.2c0,0,0,0-0.1,0c-0.2,0.2-0.4,0.3-0.6,0.2c-0.2,0-0.4-0.1-0.6-0.3c-0.1-0.1-0.2-0.3-0.2-0.5 c0-0.4,0.4-0.8,0.8-0.8c0,0,0,0,0,0c0.2,0,0.5,0.1,0.6,0.3C73.3,18.2,73.1,18.4,73.1,18.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M65.5,64c-1.7,0-3.2-0.9-4-2.4l-21.6-39c-0.8-1.4-0.7-3.1,0.1-4.5c0.8-1.4,2.4-2.2,4-2.1 c1.6,0,3.1,0.9,3.9,2.4l21.6,39c0.8,1.4,0.7,3.1-0.1,4.5C68.5,63.2,67.1,64,65.5,64L65.5,64z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M65.7,64c-2.4,0-4.3-2-4.3-4.5v-39c0-2.5,1.9-4.5,4.3-4.5c2.4,0,4.3,2,4.3,4.5v39C70,62,68.1,64,65.7,64z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaranja);
export default __webpack_public_path__ + "static/media/naranja.0dc953247bbdbbcf938ff4e0fdce5a6e.svg";
export { ForwardRef as ReactComponent };